import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '../../i18n/i18n';

function useRouting() {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    const lang = SUPPORTED_LANGUAGES.includes(params.lang) ? params.lang : DEFAULT_LANGUAGE;

    const buildPath = path => {
        if (/^https?:\/\//.test(path)) {
            return path;
        }

        return `/${lang}${path}`;
    };

    const stripLangPrefix = pathname => {
        return pathname.replace(/^\/(en|de)/, '') || '/';
    };

    const parseLocationSearch = (search = '') => {
        return Object.fromEntries(new URLSearchParams(search || location.search));
    };

    return {
        navigate,
        params,
        location,
        lang,
        buildPath,
        stripLangPrefix,
        parseLocationSearch
    };
}

export {
    useRouting
};
